module.exports = __webpack_public_path__ + "static/media/etron_t.5fec4602.pdf";